import * as requestFromServer from "./StudentsCrud";
import { callTypes, studentSlice } from "./StudentsSlice";

const {actions} = studentSlice;

export const getStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudents(queryParams)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudents(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getAllSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllSections()
    .then(response => {
      dispatch(actions.allSectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getFamilyMembers = param => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getFamilyMembers(param)
    .then(response => {
      dispatch(actions.familyMembersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = grade => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getSections(grade)
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getFamilyMember = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getFamilyMember(id)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getStudent = (page, term, id) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewStudent()
    .then(response => {
      dispatch(actions.studentFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getStudent(page, term, id)
    .then(response => {
      dispatch(actions.studentFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getUnregisteredStudent = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getUnregisteredStudent(id)
    .then(response => {
      dispatch(actions.studentFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudentInPreInterview = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getStudentInPreInterview(id)
    .then(response => {
      dispatch(actions.studentFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveStudent = student => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveStudent(student)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cancelRegistrations = (term, ids, data) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .cancelRegistrations(term, ids, data)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanStudentsState = () => dispatch => {
  return dispatch(actions.studentsStateCleaned());
};